import '@progress/kendo-theme-material/dist/all.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom';
import 'react-image-gallery/styles/css/image-gallery.css';
import { Provider } from 'react-redux';
import './animation.css';
import App from './App';
import './index.css';
import store from './store';
import { ConfigProvider } from 'antd-mobile';
import enUS from 'antd-mobile/es/locales/en-US';

if ('serviceWorker' in navigator) {
  // Unregister the old service worker if it still exists
  navigator.serviceWorker.getRegistrations().then(function (registrations) {
    for (let registration of registrations) {
      if (
        registration.active &&
        registration.active.scriptURL.includes('service-worker.js')
      ) {
        registration.unregister().then(function (success) {
          if (success) {
            console.log('Old service worker unregistered.');
          } else {
            console.log('Failed to unregister old service worker.');
          }
        });
      }
    }
  });
}

const ErrorBoundary = (props) => (
  <React.Fragment>{props.children}</React.Fragment>
);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ErrorBoundary>
        <ConfigProvider locale={enUS}>
          <App />
        </ConfigProvider>
      </ErrorBoundary>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
